export class BattlenetAccountLinkage {
    public idProvider: string;
    public gameAccountType: string;
    public gameAccountName: string;
    public eslIdLinkAccountLocation: string;

    public $onInit() {
        this.eslIdLinkAccountLocation =
            this.idProvider === "battletag_global_oauth2"
                ? "https://account.eslgaming.com/oauth2/v1/link/battlenet"
                : "https://account.eslgaming.com/oauth2/v1/link/battlenet?environment=china";
    }
}
